import { defineComponent, openBlock, createElementBlock, createStaticVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "SelectCaretTop"
});
const _hoisted_1 = {
  width: "12px",
  height: "12px",
  viewBox: "0 0 12 12",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-796.000000, -3657.000000)" fill="#42526E"><g transform="translate(580.000000, 3616.000000)"><g transform="translate(216.000000, 41.000000)"><path d="M2.31518864,9 C1.50204267,9 1.25617795,8.46286429 1.76486775,7.80178994 L5.07808171,3.49606034 C5.58729384,2.8343072 6.41341215,2.83498599 6.92210196,3.49606034 L10.2353159,7.80178994 C10.744528,8.46354309 10.496419,9 9.68499503,9 L2.31518864,9 Z" id="icon_arrow"></path></g></g></g></g>', 1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var selectCaretTop = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { selectCaretTop as default };
